import * as React from "react";
import styles from "./style.module.less";
interface Props {
    children?: React.ReactNode;
}
export default class CenteredLayout extends React.Component<Props> {
    render() {
        return <div className={styles.container}>{this.props.children}</div>;
    }
    static displayName = "CenteredLayout";
}
